<template>
  <div class="e-block e-block--flow">
    <div class="e-block__title">{{ title }}</div>
    <div class="e-row e-row--gutters10">
      <div class="e-col-sm-12" :class="`${smallCards ? 'e-col' : 'e-col-auto'}`" :key="`flow-${index}`" v-for="(item, index) in formatterItems">
        <template v-if="item.value">
          <div class="e-flow-selector" :class="item.class" @click="selectFlow(item.value)">
            <div class="e-flow-selector__title" v-html="item.title"></div>
          </div>
        </template>
        <template v-else-if="item.link">
          <router-link :to="item.link" class="e-flow-selector" :class="item.class">
            <div class="e-flow-selector__title" v-html="item.title"></div>
          </router-link>
        </template>
        <template v-else>
          <div class="e-flow-selector" :class="item.class">
            <div class="e-flow-selector__title" v-html="item.title"></div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { FLOW_TYPE } from '@/store';

const urlParams = new URLSearchParams(window.location.search);
const fa = urlParams.get('fa') || false;

export default {
  components: {},
  props: {
    title: {
      type: String,
      required: true,
    },
    items: {
      type: Array,
      required: true,
    },
  },
  name: 'FlowSelector',
  data() {
    return {
      FLOW_TYPE,
      fa,
    };
  },
  mounted() {},
  computed: {
    ...mapState(['selectedFlow']),
    formatterItems() {
      return this.items.map((item) => ({
        ...item,
        class: `e-flow-selector--${item.class}${!fa ? '-fa' : ''} ${this.smallCards ? 'e-flow-selector--sm' : ''} `,
      }));
    },
    smallCards() {
      return this.items.length > 4;
    },
  },
  methods: {
    ...mapActions(['setSelectedFlow']),

    selectFlow(value) {
      this.setSelectedFlow(value);
    },
  },
};
</script>

<style lang="scss">

</style>
